module.exports = __webpack_public_path__ + "static/media/collection-bird-04-effect.92d82de4.png";